import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUser } from "../context/UserContext";
import LoadingScreen from "../LoadingScreen";

const RequireAuth = ({ redirectPath = "/authentication", children }) => {
  const { currentUser, loading } = useCurrentUser();
  if (loading) {
    return <LoadingScreen />;
  }
  if (!currentUser) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};

export default RequireAuth;
